import { useEffect } from "react";
import "@/App.css";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import EditorialMarquee from "./components/Marquee";
import Gallery from "./components/Gallery";
import About from "./components/About";
import AboutIt from "./components/AboutIt";
import Expo from "./components/Expo";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { originalWorks, tapestries, tapestryShared } from "./data";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const saved = sessionStorage.getItem("previewScrollY");
    if (saved) {
      setTimeout(() => lenis.scrollTo(parseInt(saved, 10), { immediate: true }), 400);
    }
    const save = () => sessionStorage.setItem("previewScrollY", String(window.scrollY));
    window.addEventListener("beforeunload", save);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("beforeunload", save);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="bg-linen text-ink min-h-screen">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <Gallery id="original" chapter="original" items={originalWorks} testidPrefix="original" twoCol />
          <Gallery id="tapestry" chapter="tapestry" items={tapestries} testidPrefix="tapestry" shared={tapestryShared} />
          <About />
          <AboutIt />
          <Expo />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, border: "1px solid #0A0A0B", background: "#F6F4ED", color: "#0A0A0B" } }} />
      </div>
    </LanguageProvider>
  );
}

export default App;
